import React from 'react';
import { Stack, TextField, Typography } from '@mui/material';
import { rootSx, headerSx } from '../styles';
import {titleSx, subtitleSx, amountInputSx} from './styles';
import { useTranslation } from 'react-i18next';

interface AmountStepProps {
  value: string;
  onChange: (value: string) => void;
  error?: string;
  walletBalance: number;
}

const AmountStep: React.FC<AmountStepProps> = ({ value, onChange, error, walletBalance }) => {
  const { t } = useTranslation('area');

  return (
    <Stack sx={rootSx}>
      <Stack sx={headerSx}>
        <Typography sx={titleSx}>{t('MODAL_WITHDRAW.CONTENT.AMOUNT_STEP.TITLE')}</Typography>
        <Typography sx={subtitleSx}>{t('MODAL_WITHDRAW.CONTENT.AMOUNT_STEP.AVAILABLE_BALANCE')} : {walletBalance}€</Typography>
      </Stack>

      <TextField
        placeholder="0.00€"
        value={value}
        onChange={(e) => {
          const val = e.target.value;
          if (val === '' || Number(val) >= 0) onChange(val);
        }}
        error={Boolean(error)}
        helperText={error}
        type="number"
        fullWidth
        inputProps={{ min: 0 }}
        sx={amountInputSx}
      />
    </Stack>
  );
};

export default AmountStep;